module.exports = __webpack_public_path__ + "img/filter-type-butt.60f87676.svg";